import { JsonProperty } from "@nstep-common/utils";

export enum RoleProfiles {
	Cardholder = '4855BB6D',
	Operator = '6B39E8AF',
	Nation = '0112BC14'
}

export class RoleDto {
	@JsonProperty({ type: Number })
	roleId!: number;

	@JsonProperty({ type: String, nullable: true })
	roleName: string | null = null;

	@JsonProperty({ type: String, nullable: true })
	description: string | null = null;

	@JsonProperty({ type: String, nullable: true })
	profileId: string | null = null;

	constructor(data: Partial<RoleDto> | null = null) {
		if (data) {
			Object.assign(this, data);
		}
	}
}